<span *ngIf="count !== null && count !== undefined" class="badge badge_fill-gray">
  {{ count }}
</span>
<span *ngIf="notificationCount" class="badge badge_notification">
  {{ notificationCount }}
</span>
<span><ng-content></ng-content></span>
